export class PerformanceLogPolicy {
  shouldEmitDetailedTiming(): boolean {
    return process.env.CODEMATION_PERFORMANCE_LOGGING === "true";
  }
}
